import React from 'react';
import PropTypes from 'prop-types';
import withCookieConsentSocialMedia from './withCookieConsentSocialMedia';
import { TwitterEmbed } from 'react-social-media-embed';

const BBSocialMediaEmbedTwitter = ({ postURL }) => (
  <div>
    <TwitterEmbed url={postURL} width="100%" />
  </div>
);

BBSocialMediaEmbedTwitter.propTypes = {
  postURL: PropTypes.string.isRequired,
};

export default withCookieConsentSocialMedia(BBSocialMediaEmbedTwitter);
